<template>
  <SettingsContainerDiv type="inner" :isSession="true">
    <SettingArea
      :comingSoon="false"
      :isEnabled="false"
      :title="microphone.title"
      :isSession="true"
      :description="microphone.description"
      :isSelect="true"
      :selectOptions="microphone.options"
      :currentSelection="microphone.current"
      @selected="updatePreference('microphone', $event)"
    >
    </SettingArea>
    <SettingArea
      :comingSoon="false"
      :isEnabled="false"
      :title="camera.title"
      :isSession="true"
      :description="camera.description"
      :isSelect="true"
      :selectOptions="camera.options"
      :currentSelection="camera.current"
      @selected="updatePreference('camera', $event)"
    >
    </SettingArea>
    <SettingArea
      :comingSoon="false"
      :isEnabled="false"
      :title="speaker.title"
      :isSession="true"
      :description="speaker.description"
      :isSelect="true"
      :selectOptions="speaker.options"
      :currentSelection="speaker.current"
      @selected="updatePreference('speaker', $event)"
    >
    </SettingArea>
  </SettingsContainerDiv>
</template>

<script>
import { mapState } from "vuex";
import {
  changeAudioOutput,
  republishMediaWithNewDevice,
} from "../../SessionHelpers/media";
import SettingArea from "../../../../BookingPages/Settings/BaseComponents/SettingArea";
import SettingsContainerDiv from "../../../../BookingPages/Settings/BaseComponents/SettingsContainerDiv";

export default {
  name: "SettingsDevice",
  data() {
    return {
      microphone: {
        title: "Microphone",
        description: "Set your preferred microphone.",
        options: [],
        current: null,
      },
      camera: {
        title: "Camera",
        description: "Set your preferred camera.",
        options: [],
        current: null,
      },
      speaker: {
        title: "Speaker",
        description: "Set your preferred speaker.",
        options: [],
        current: null,
      },
      navigatorUnsupported: false,
      devices: [
        {
          device: "microphone",
          kind: "audioinput",
        },
        {
          device: "camera",
          kind: "videoinput",
        },
        {
          device: "speaker",
          kind: "audiooutput",
        },
      ],
    };
  },
  components: {
    SettingArea,
    SettingsContainerDiv,
  },
  computed: {
    ...mapState({
      current: (state) => state.room.current,
      sessionPreferences: (state) => state.room.sessionPreferences,
    }),
  },
  mounted() {
    this.getAndSetAvailableDevices();
  },
  methods: {
    async getAndSetAvailableDevices() {
      if (
        !navigator ||
        !navigator.mediaDevices ||
        !navigator.mediaDevices.enumerateDevices
      ) {
        this.navigatorUnsupported = true;
        return;
      }
      /* Get all available devices */
      let mediaDevices = await navigator.mediaDevices.enumerateDevices();

      /* Set up counters for devices without a label */
      let microphonecount = 0;
      let speakercount = 0;
      let cameracount = 0;
      for (var i = 0; i < mediaDevices.length; i++) {
        let device = mediaDevices[i];
        let option = {
          value: device.deviceId,
          kind: device.kind,
        };
        if (device.kind == "audioinput") {
          microphonecount++;
          option.label = device.label || `Microphone ${microphonecount}`;
          this.microphone.options.push(option);
        } else if (device.kind == "audiooutput") {
          speakercount++;
          option.label = device.label || `Speaker ${speakercount}`;
          this.speaker.options.push(option);
        } else if (device.kind == "videoinput") {
          cameracount++;
          option.label = device.label || `Camera ${cameracount}`;
          this.camera.options.push(option);
        }
      }
      if (this.current) {
        this.setCurrentDevices();
      } else {
        console.warn("Current devices not found.");
      }
    },
    setCurrentDevices() {
      /* 'this.current' is set when initializing room */
      for (var i = 0; i < this.devices.length; i++) {
        let device = this.devices[i];
        /* If a current exists for the device */
        if (this.current[device.kind] && this.current[device.kind].deviceId) {
          /* If the id of the current is default */
          if (this.current[device.kind].deviceId == "default") {
            this[device.device].current = this[device.device].options[0].value; // called value here for html select-option tags
          } else {
            this[device.device].current = this.current[device.kind].deviceId; // called deviceId here because... it's deviceId
          }
        }
      }
    },
    async updatePreference(preference, deviceId) {
      if (!preference || !deviceId) {
        return console.warn("missing preference type or deviceId");
      }
      /* 1. Update Vuex preferences */
      const updateData = { field: preference, newValue: deviceId };
      await this.$store.dispatch("room/updatePreferenceField", updateData);

      /* 2. Update current in Vuex */
      const devices = await navigator.mediaDevices.enumerateDevices();
      const newDevice = devices.find((device) => device.deviceId === deviceId);
      if (!newDevice) {
        console.log("Device not found.");
      } else {
        await this.$store.dispatch("room/setCurrentDevice", newDevice);
      }

      /* 3. Update current in passed options */
      this[preference].current = deviceId;

      /* 4. Stop publishing with current device and republish with new device */
      if (preference == "speaker") {
        await changeAudioOutput();
      } else {
        await republishMediaWithNewDevice(preference);
      }
    },
  },
};
</script>
